import { Button } from '@material-ui/core';
import { PictureAsPdf, FileCopy } from '@material-ui/icons';
import { rhythm } from 'Themes/typography';
import { downloadFile } from 'Utils';
import React from 'react';
import Error from 'Components/Error';
import styled from 'styled-components';

import ClearFile from '../components/ClearFile';
import HiddenLink from '../components/HiddenLink';
import FieldError from '../components/FieldError';

// TODO: this entire component already exists in the Ticket page, refactor into common

const Container = styled.div`
  padding-top: ${rhythm(1.5)};
  border-top: 2px solid ${({ theme }) => theme.palette.blue.light};
  border-bottom: 2px solid ${({ theme }) => theme.palette.blue.light};
  height: 100%;
`;
const Explanation = styled.p`
  padding-top: 3px;
  color: ${({ theme }) => theme.palette.blue.main};
`;
const Heading = styled.h1`
  font-size: 1rem;
`;

const CustomButton = styled.div`
  &&& {
    background: #fff;
    border: 1px solid ${({ theme }) => theme.palette.primary.main};
    font-weight: 600;
    font-size: 1rem;
    text-transform: uppercase;
    position: relative;
    color: ${({ disabled }) =>
      disabled ? 'rgba(0, 0, 0, 0.26)' : 'rgba(0, 0, 0, 0.87)'};
    padding: 6px 16px;
    min-width: 64px;
    box-sizing: border-box;
    transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
      box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
      border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    line-height: 1.75;
    font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
    border-radius: 4px;
    letter-spacing: 0.02857em;
    text-align: center;
    box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.2),
      0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12);
    cursor: pointer;

    &:hover {
      background-color: #ffca28 !important;
    }
  }
`;

const FilesList = styled.ul`
  list-style: none;
  margin: 0;
  margin-top: ${rhythm(1)};
`;

// Add this for specific type of file for upload
// accept: `application/msword,
// application/vnd.openxmlformats-officedocument.wordprocessingml.document,
// application/vnd.ms-excel,
// application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
// application/pdf`,
// })`

const FileInput = styled.input.attrs({
  type: 'file',
  size: 5242880,
})`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  font-size: 0;
`;

const File = styled.li`
  position: relative;
  display: flex;
  align-items: center;
`;

const FileName = styled.span`
  font-size: 0.875rem;
  margin-left: 0.5rem;
`;
const FileDownload = styled.button`
  &&& {
    background: transparent;
    padding: 0;
    margin: 0;
    border: 0;
    font-size: 0.875rem;
    margin-left: 0.5rem;

    &:focus {
      outline: 0;
    }

    &:hover {
      border-bottom: 1px solid ${({ theme }) => theme.palette.blue.light};
      background: transparent !important;
      cursor: pointer;
    }
  }
`;

class AddSpecifications extends React.PureComponent {
  attachmentFile1 = React.createRef();
  attachmentFile2 = React.createRef();
  attachmentFile3 = React.createRef();
  attachmentFile4 = React.createRef();
  attachmentFile5 = React.createRef();
  attachmentFile6 = React.createRef();
  attachmentFile7 = React.createRef();

  state = {
    error: null,
  };

  componentDidCatch(error, info) {
    this.setState({
      error,
    });
  }

  onDownloadFile = downloadFile;

  onDownloadError = error => {
    console.error(error);
    this.setState({
      error,
    });
  };
  onErrorCancel = () => {
    this.setState({
      error: null,
    });
  };

  printFile = (sheet, index) => {
    if (!sheet) return <div />;
    if (sheet.assetId) {
      return (
        <File key={index}>
          {sheet.originalName.includes('.pdf') ? (
            <PictureAsPdf />
          ) : (
            <FileCopy />
          )}

          <FileDownload
            onClick={this.onDownloadFile(
              sheet.assetId,
              this[`attachmentFile${index}`]
            )(this.onDownloadError)}
          >
            {sheet.originalName}
          </FileDownload>
          <HiddenLink
            innerRef={this[`attachmentFile${index}`]}
            download={sheet.originalName}
          />

          {this.props.shortlisted ? null : (
            <ClearFile
              onClick={this.props.onAttachmentRemove(index)}
              disabled={this.props.isSlipDiscarded}
            />
          )}
        </File>
      );
    }
    return (
      <File key={index}>
        {sheet.type === 'application/pdf' ? <PictureAsPdf /> : <FileCopy />}
        <FileName>{sheet.name}</FileName>

        {this.props.shortlisted ? null : (
          <ClearFile onClick={this.props.onAttachmentRemove(index)} />
        )}
      </File>
    );
  };

  checkFreeAtachPlace = () => {
    let i;
    for (i = 1; i < 8; i++) {
      if (this.props[`attachmentFile${i}`] === null) {
        return this.props.onAddAttachment(`attachmentFile${i}`);
      }
    }
  };

  isDisabled = () => {
    let i;
    let d = true;
    for (i = 1; i < 8; i++) {
      if (this.props[`attachmentFile${i}`] === null) {
        d = false;
      }
    }
    return d;
  };

  render() {
    const { shortlisted } = this.props;
    return (
      <Container>
        <Error errors={this.state.error} onCancel={this.onErrorCancel} />
        <Heading>
          <div>{shortlisted ? 'Specification sheets' : ' Add attachment '}</div>
          {this.props.error ? (
            <FieldError>{`*${this.props.error}`}</FieldError>
          ) : null}
        </Heading>
        {shortlisted ? null : (
          <React.Fragment>
            <CustomButton
              component="div"
              disabled={this.props.isSlipDiscarded || this.isDisabled()}
              fullWidth
              variant="contained"
            >
              <FileInput
                disabled={this.props.isSlipDiscarded || this.isDisabled()}
                onChange={this.checkFreeAtachPlace()}
                innerRef={this.props.attachmentRef}
              />
              UPLOAD document
            </CustomButton>
            <Explanation>
              You can upload up to 7 files. Each file cannot exceed 5MB.
            </Explanation>
          </React.Fragment>
        )}
        <FilesList>
          {this.printFile(this.props[`attachmentFile1`], 1)}
          {this.printFile(this.props[`attachmentFile2`], 2)}
          {this.printFile(this.props[`attachmentFile3`], 3)}
          {this.printFile(this.props[`attachmentFile4`], 4)}
          {this.printFile(this.props[`attachmentFile5`], 5)}
          {this.printFile(this.props[`attachmentFile6`], 6)}
          {this.printFile(this.props[`attachmentFile7`], 7)}
        </FilesList>
      </Container>
    );
  }
}

export default AddSpecifications;
